export const compareData = (data: any) => {
  let tableData: any[] = [];
  let comparisonRules: any[] = [];
  data.forEach((vehicle: any) => {
    comparisonRules.push(...vehicle.attributes.highlights.filter((rule: any) => comparisonRules.findIndex(el => el.attribute_id === rule.attribute_id) === -1))
  });
  data.forEach((vehicle: any) => {
    comparisonRules.push(...vehicle.attributes.equipments.filter((rule: any) => comparisonRules.findIndex(el => el.attribute_id === rule.attribute_id) === -1))
  });
  comparisonRules.forEach((rule: any, ruleIndex: number) => {
    tableData.push([rule.name]);
    data.forEach((vehicle: any) => {
      let currentHighlightIndex: number = vehicle.attributes.highlights.findIndex((el: any) => el.attribute_id === rule.attribute_id);
      let currentEquipmentIndex: number = vehicle.attributes.equipments.findIndex((el: any) => el.attribute_id === rule.attribute_id);
      let currentRule: any = {};
      if(currentHighlightIndex !== -1 || currentEquipmentIndex !== -1) {
        currentRule = currentHighlightIndex !== -1 ? vehicle.attributes.highlights[currentHighlightIndex] : vehicle.attributes.equipments[currentEquipmentIndex];
        tableData[ruleIndex].push(currentRule.data_type === 'boolean' ? currentRule.value === '1' ? true : false : currentRule.value);
      } else {
        tableData[ruleIndex].push('-');
      }
    });
  });
  return {
    vehicles: data.map((vehicle: any) => vehicle.vehicle),
    attributes: tableData
  };
}